import React, { useEffect, useRef } from 'react';

interface IAnimatedNumberProps {
    count: number;
    duration?: number;
    prefix?: string;
    suffix?: string;
}

const AnimatedNumber = ({ count, duration = 2000, prefix = '', suffix = '' }: IAnimatedNumberProps) => {
    const spanRef: React.Ref<HTMLSpanElement> = useRef(null);
    const end = count;

    useEffect(() => {
        let start = 0;
        const isFloat = !Number.isInteger(end);
        const frameRate = 1000 / 60;
        const totalFrames = Math.round(duration / frameRate);
        const increment = end / totalFrames;
        let frame = 0;

        const counter = setInterval(() => {
            frame++;
            start += increment;

            const displayValue =
                frame >= totalFrames
                    ? end
                    : isFloat
                        ? parseFloat(start.toFixed(1))
                        : Math.round(start);

            if (spanRef.current) {
               spanRef.current.textContent = `${prefix}${displayValue.toLocaleString()}${suffix}`;
            }

            if (frame >= totalFrames) clearInterval(counter);
        }, frameRate);

        return () => clearInterval(counter);
    }, [end, duration, prefix, suffix]);

    return <span ref={spanRef}>{prefix}0{suffix}</span>;
};

export default AnimatedNumber;
